import React from 'react';
import {
	Stack
} from '@mui/material';
import Layout from '../../components/Layout';
import Title from '../../components/Title';
import PaperWrapper from '../../components/PaperWrapper';
import TransparentContainer from '../../components/TransparentContainer';
import BigTitle from '../../components/BigTitle';
import { useThemeStatics } from '../../hooks/useThemeConfig';

function TransparentTemplate({ templateRef, view, children }) {
  const { transparentContainer, layout, bigTitle, titulo, estilos } = view;
  const config = useThemeStatics();
  const transparentContainerProps = {
    ...transparentContainer,
    opacity: config.transparenceOpacity
  };
  return (
    <Layout {...layout}>
  		<TransparentContainer {...transparentContainerProps} heightRef={templateRef} > 
                <Stack ref={templateRef} sx={estilos.stack}>
                    <BigTitle {...bigTitle}/> 
                    <Title sx={estilos.titulo}>{titulo}</Title>
                    {children}
                </Stack>
    	   </TransparentContainer>
    </Layout>
  );
}

function CardTemplate({ templateRef, view, children }) {
    const { transparentContainer, layout, bigTitle, titulo, estilos } = view;
    return (
        <Layout {...layout}>
            <BigTitle {...bigTitle}/> 
            <TransparentContainer {...transparentContainer} heightRef={templateRef} > 
                <PaperWrapper sx={estilos.paperWrapper}>
                    <Stack ref={templateRef} sx={estilos.stack}>
                        <Title sx={estilos.titulo}>{titulo}</Title>
                        {children}
                    </Stack>
                </PaperWrapper>
            </TransparentContainer>
        </Layout>
    );
  }


function MainTemplate({ children, ...rest }) {   
    const tipoLayout = rest.view.layout.type;
    const transparente = tipoLayout === 'transparent';
    const tarjeta = tipoLayout === 'card';
    return tarjeta ? <CardTemplate {...rest}>{children}</CardTemplate> : (
        transparente ? <TransparentTemplate {...rest}>{children}</TransparentTemplate> : (
            <CardTemplate {...rest}>{children}</CardTemplate>
        )
    );
  }


export default MainTemplate;
